import { type FC } from 'react';

import { PriceTableRowItem } from '@vakantiesnl/components/src/atoms/PriceTableRowItem';
import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { type MicroCopy, type Search } from '@vakantiesnl/types';

import { useCustomStyles } from '../PriceTable.style';

type Props = {
	roomIndex: number;
	party: Search.PartyComposition;
	pricePerAdult: number;
	pricePerChild: number;
	pricePerBaby: number;
	microCopies: MicroCopy;
	isAccoOnly?: boolean;
};

/** Price overview display per room/accommodation */
export const PerRoomSummary: FC<Props> = ({
	roomIndex,
	party: { adults, children, babies },
	pricePerAdult,
	pricePerChild,
	pricePerBaby,
	microCopies,
	isAccoOnly = false,
}) => {
	const { classes, cx } = useCustomStyles();

	return (
		<>
			<thead>
				<tr>
					<th>
						<Typography variant="headingXs" as="h5" className={classes.title}>
							{isAccoOnly ? microCopies['common.accommodation'] : microCopies['common.room']}{' '}
							{roomIndex + 1}
						</Typography>
					</th>
				</tr>
			</thead>

			<tbody className={cx(classes.tableBody, classes.roomTableBody)}>
				{adults > 0 && (
					<PriceTableRowItem
						title={`${adults}x ${microCopies['common.adult']}`}
						priceTotal={pricePerAdult * adults}
					/>
				)}
				{children > 0 && (
					<PriceTableRowItem
						title={`${children}x ${microCopies['common.child']}`}
						priceTotal={pricePerChild * children}
					/>
				)}
				{babies > 0 && (
					<PriceTableRowItem
						title={`${babies}x ${microCopies['common.baby']}`}
						priceTotal={pricePerBaby * babies}
					/>
				)}
			</tbody>
		</>
	);
};
